import { Component, input } from '@angular/core';
import { RvbSummary } from '../../models/rent-vs-buy.models';
import { RvbFormatPipe } from '../../pipes/rvb-format.pipe';

@Component({
  selector: 'hs-rvb-breakdown-cards',
  standalone: true,
  imports: [RvbFormatPipe],
  template: `
    <div class="breakdown">

      <!-- BUY CARD -->
      <div class="breakdown__card">
        <div class="breakdown__title">
          <span class="breakdown__badge breakdown__badge--buy">BUY</span>
          {{ horizon() }}-year breakdown
        </div>
        <div class="breakdown__line">
          <span>Down payment</span>
          <span class="breakdown__val">{{ summary().downPayment | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Closing costs</span>
          <span class="breakdown__val">{{ summary().closingCosts | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Mortgage payments</span>
          <span class="breakdown__val">{{ summary().totalMortgagePaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>&nbsp;&nbsp;Interest paid</span>
          <span class="breakdown__val">{{ summary().totalInterestPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Property taxes</span>
          <span class="breakdown__val">{{ summary().totalPropTaxPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Insurance</span>
          <span class="breakdown__val">{{ summary().totalInsPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>HOA</span>
          <span class="breakdown__val">{{ summary().totalHoaPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Maintenance</span>
          <span class="breakdown__val">{{ summary().totalMaintPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line breakdown__line--positive">
          <span>Home equity at sale</span>
          <span class="breakdown__val">-{{ summary().equityRecovered | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line breakdown__line--positive">
          <span>Tax deduction benefit</span>
          <span class="breakdown__val">-{{ summary().taxDeductBenefit | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line breakdown__line--total">
          <span>Net cost</span>
          <span class="breakdown__val">{{ summary().finalBuyNetCost | rvbFormat:'dollar' }}</span>
        </div>
      </div>

      <!-- RENT CARD -->
      <div class="breakdown__card">
        <div class="breakdown__title">
          <span class="breakdown__badge breakdown__badge--rent">RENT</span>
          {{ horizon() }}-year breakdown
        </div>
        <div class="breakdown__line">
          <span>Starting rent / mo</span>
          <span class="breakdown__val">{{ summary().monthlyRentStart | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Rent at year {{ horizon() }}</span>
          <span class="breakdown__val">{{ summary().rentAtExit | rvbFormat:'dollar' }}/mo</span>
        </div>
        <div class="breakdown__line">
          <span>Total rent paid</span>
          <span class="breakdown__val">{{ summary().totalRentPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Renter's insurance</span>
          <span class="breakdown__val">{{ summary().totalRentersInsPaid | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line">
          <span>Down pmt invested</span>
          <span class="breakdown__val">{{ summary().downPmtInvested | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line breakdown__line--positive">
          <span>Portfolio at exit</span>
          <span class="breakdown__val">-{{ summary().portfolioFinal | rvbFormat:'dollar' }}</span>
        </div>
        <div class="breakdown__line breakdown__line--total">
          <span>Net cost</span>
          <span class="breakdown__val">{{ summary().finalRentNetCost | rvbFormat:'dollar' }}</span>
        </div>
      </div>

    </div>
  `,
  styleUrl: './rvb-breakdown-cards.component.scss',
})
export class RvbBreakdownCardsComponent {
  readonly summary = input.required<RvbSummary>();
  readonly horizon = input.required<number>();
}
